import React from 'react';
import { motion } from 'framer-motion';
interface CyberpunkButtonProps {
  children: React.ReactNode;
  variant?: 'blue' | 'pink';
  onClick?: () => void;
  className?: string;
}
export function CyberpunkButton({
  children,
  variant = 'blue',
  onClick,
  className = ''
}: CyberpunkButtonProps) {
  const color = variant === 'blue' ? '#00f0ff' : '#ff006e';
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={onClick} className={`
        relative px-8 py-3 font-bold uppercase tracking-widest text-white 
        bg-transparent border-2 transition-all duration-300
        group overflow-hidden ${className}
      `} style={{
    borderColor: color,
    boxShadow: `0 0 10px ${color}40`,
    fontFamily: "'Orbitron', sans-serif"
  }} data-id="element-23">
      {/* Background fill on hover */}
      <div className="absolute inset-0 w-full h-full transition-all duration-300 ease-out transform translate-x-full group-hover:translate-x-0 opacity-20" style={{
      backgroundColor: color
    }} data-id="element-24" />

      {/* Button Content */}
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-25">
        {children}
      </span>

      {/* Corner Accents */}
      <div className="absolute top-0 left-0 w-2 h-2 bg-white" data-id="element-26" />
      <div className="absolute bottom-0 right-0 w-2 h-2 bg-white" data-id="element-27" />

      {/* Glitch effect lines on hover */}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 pointer-events-none" data-id="element-28">
        <div className="absolute top-1/4 left-0 w-full h-[1px]" style={{
        backgroundColor: color
      }} data-id="element-29" />
        <div className="absolute bottom-1/4 left-0 w-full h-[1px]" style={{
        backgroundColor: color
      }} data-id="element-30" />
      </div>
    </motion.button>;
}